import { EntityAdapter, EntityState, createEntityAdapter } from "@ngrx/entity";
import { createActionGroup, createFeature, createReducer, createSelector, emptyProps, on, props } from "@ngrx/store";
import { AuthUserActions, authUserFeature } from "./authUser.store";
// replace with your real Order type
import { Cart, OrderPublic } from "./../../../globalTypes/order.types";

export interface OrdersState extends EntityState<OrderPublic> {
  order: Partial<OrderPublic> | null;
  cart: Partial<Cart> | null;
  orders: OrderPublic[];
  isLoading: boolean;
  sideCartOpen: boolean;
}

const adapter: EntityAdapter<OrderPublic> = createEntityAdapter<OrderPublic>();

const getOrdersState = (): OrdersState => adapter.getInitialState({
  order: null,
  cart: null,
  isLoading: true,
  orders: [],
  sideCartOpen: false,
});

export const OrdersActions = createActionGroup({
  source: 'ORDERS',
  events: {
    'Orders Loading': (isLoading: boolean) => ({ isLoading }),
    'Orders Loaded': props<{ orders: OrderPublic[] }>(),
    'Update Cart': props<{ cart: Partial<Cart> }>(),
    'Order Updated': props<{ orderId: string, order: Partial<OrderPublic> }>(),
    'Orders Removed': props<{ orderIds: string[] }>(),
    'Order Removed': props<{ orderId: string }>(),
    'All Orders Removed': emptyProps(),
    'Select Order': props<{ orderId: string }>(),
    'Toggle Side Cart': props<{ isOpen: boolean | null}>(),
  }
});

const reducer = createReducer(
  getOrdersState(),
  on(OrdersActions.ordersLoading, (state, { isLoading }) => ({ ...state, isLoading })),
  on(OrdersActions.updateCart, (state, { cart }) => ({ ...state, cart })),
  on(OrdersActions.ordersLoaded, (state, action) =>
    adapter.upsertMany(action.orders, { ...state, isLoading: false })
  ),
  on(OrdersActions.orderUpdated, (state, action) =>
    adapter.updateOne({ id: action.orderId, changes: action.order }, { ...state, isLoading: false })
  ),
  on(OrdersActions.ordersRemoved, (state, action) =>
    adapter.removeMany(action.orderIds, { ...state, isLoading: false })
  ),
  on(OrdersActions.orderRemoved, (state, action) =>
    adapter.removeOne(action.orderId, { ...state, isLoading: false })
  ),
  on(OrdersActions.allOrdersRemoved, (state) =>
    adapter.removeAll({ ...state, isLoading: false })
  ),
  on(OrdersActions.selectOrder, (state, action) => ({
    ...state,
    order: state.orders.find(order => order.id === action.orderId) || null
  })),
  on(OrdersActions.toggleSideCart, (state, action) => ({ ...state, sideCartOpen: action.isOpen === null ? !state.sideCartOpen : action.isOpen})),
  on(AuthUserActions.logOut, () => getOrdersState()),
);

export const ordersFeature = createFeature({
  name: 'orders',
  reducer,
  extraSelectors: ({ selectCart, selectEntities, selectIds }) => ({
    selectOrders: createSelector(
      selectIds,
      selectEntities,
      (ids, entities) => ids ? ids.map((id) => entities[id]) : []
    ),
    selectCartCount: createSelector(selectCart, (cart) => {
      if(cart && cart.orderItems_on_order) return cart.orderItems_on_order.reduce((a,c)=>{
        a = c.quantity + a;
        return a;
      }, 0)
      return 0 }),
  })
});
